"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * DefaultModalClose is rendered if `ModalClose` is not passed to Modal
 * If providing ModalClose, you will need to receive an `onClick` prop and
 * use like below.
 *
 */


var DefaultModalClose = function DefaultModalClose(_ref) {
  var onClick = _ref.onClick;
  return _react.default.createElement("button", {
    type: "button",
    className: "DefaultModalClose absolute",
    style: {
      width: "2rem",
      height: "2rem",
      top: 0,
      right: 0
    },
    onClick: onClick
  }, _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "white",
    width: "100%",
    height: "100%"
  }, _react.default.createElement("path", {
    d: "M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
  })));
};

DefaultModalClose.propTypes = {
  onClick: _propTypes.default.func.isRequired
};
var _default = DefaultModalClose;
exports.default = _default;